import * as React from 'react';

export const mxFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_387)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_387'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_387)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M17.3071 9.70908C17.3241 9.84538 17.333 9.98464 17.333 10.1254C17.333 11.9661 15.8404 13.4587 13.9997 13.4587C12.1589 13.4587 10.6664 11.9661 10.6664 10.1254C10.6664 9.98464 10.6752 9.84538 10.6923 9.70834C10.8975 10.9883 12.2997 11.9772 13.9997 11.9772C15.6997 11.9772 17.1019 10.9876 17.3071 9.70834V9.70908Z'
                    fill='#006847'
                />
                <circle
                    cx='13.9997'
                    cy='8.66667'
                    r='2'
                    fill='#AE6A3E'
                />
                <rect
                    x='20'
                    width='8'
                    height='20'
                    fill='#F93939'
                />
                <rect
                    width='8'
                    height='20'
                    fill='#006847'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_387'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
